import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { Firestore, collection, query, where, getDocs } from '@angular/fire/firestore';
import { Result } from '../models/result.interface';

@Injectable({
  providedIn: 'root'
})
export class PersonService {
  private localUrl = 'http://localhost:3000';
  private remoteUrl = 'https://nest.equestrian.digital/v1';
  private baseUrl = window.location.hostname.includes('localhost') ? this.localUrl : this.remoteUrl;

  constructor(
    private http: HttpClient,
    private firestore: Firestore
  ) { }

  public getPerson(personId, showId): Observable<any> {
    console.log('Getting person in service');
    return this.http.get(`https://nest.equestrian.digital/v1/resultados/showProfile?personId=${personId}&showId=${showId}`);
  }

  public getLicencias(showId): Observable<any> {
    return this.http.get(`https://nest.ecuestre.digital/v1/binomios/licencias/${showId}`);
  }
}
